<template>
  <nav class="site-nav" aria-label="Main navigation">
    <router-link to="/" exact class="nav-link">Home</router-link>
    <router-link to="/extraction" class="nav-link">Extraction</router-link>
    <router-link to="/where-to-buy" class="nav-link">Where to Buy</router-link>
    <router-link to="/customer-service" class="nav-link">Support</router-link>
  </nav>
</template>

<script>
export default {
  name: "SiteNav",
};
</script>

<style scoped>
.site-nav {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0 20px;
  background: transparent;
  padding: 0;
  min-width: 0;
}

.nav-link {
  box-sizing: border-box;
  color: #64748b;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0;
  border-bottom: 2px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.nav-link:hover {
  color: #0d5c7a;
}

.nav-link.router-link-active {
  color: #0c1929;
  border-bottom-color: #0d5c7a;
}

@media (max-width: 640px) {
  .site-nav {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
    min-width: 0;
  }

  .nav-link {
    min-width: 0;
    padding: 8px 10px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid rgba(12, 25, 41, 0.12);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.42);
    line-height: 1.3;
  }

  .nav-link.router-link-active {
    background: rgba(255, 255, 255, 0.85);
  }
}

@media (max-width: 420px) {
  .site-nav {
    grid-template-columns: 1fr;
  }
}
</style>
